import Axios from 'axios';

export default {
    setCode(code) {
        return Axios.post('/api/sales-rep-selection/set-code', {
            code: code,
        })
    },
}
